import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useFormHook from '@shared/hooks/useFormHook';

const schema = yup.object({
    title: yup.string().trim().required('Title is required'),
    translationTitle: yup.string().trim().required('Translation title is required'),
    translationCode: yup.string().trim().required('Translation code is required')
});

export default function NomenclatureTranslationModal({
    onClose,
    onConfirm,
    record
}) {
    const { modalRef } = useFormHook({}, onClose);
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            title: record?.note || '',
            translationTitle: record?.transNote || '',
            translationCode: record?.transValue || ''
        }
    });

    const handleFormSubmit = (formValues) => {
        onConfirm(formValues);
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {t('additionalSettings.nomenclatureTranslations.modal.addTitle') || 'Add translation'}
                        </h4>
                        <form id="nomenclatureTranslationForm" className='width-100' onSubmit={handleSubmit(handleFormSubmit)}>
                            <div className="form-group">
                                <span className="span-bold">
                                    {t('additionalSettings.nomenclatureTranslations.modal.titleLabel') || 'Title'}
                                </span>
                                <input
                                    type="text"
                                    disabled
                                    className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                    placeholder={t('additionalSettings.nomenclatureTranslations.modal.titlePlaceholder') || 'Enter title'}
                                    {...register('title')}
                                />
                                {errors.title && (
                                    <div className="invalid-feedback">
                                        {errors.title.message}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <span className="span-bold">
                                    {t('additionalSettings.nomenclatureTranslations.modal.translationTitleLabel') || 'Translation title'}
                                    <span className="required">*</span>
                                </span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.translationTitle ? 'is-invalid' : ''}`}
                                    placeholder={t('additionalSettings.nomenclatureTranslations.modal.translationTitlePlaceholder') || 'Enter translation title'}
                                    {...register('translationTitle')}
                                />
                                {errors.translationTitle && (
                                    <div className="invalid-feedback">
                                        {errors.translationTitle.message}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <span className="span-bold">
                                    {t('additionalSettings.nomenclatureTranslations.modal.translatedCodeLabel') || 'Translation code'}
                                    <span className="required">*</span>
                                </span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.translationCode ? 'is-invalid' : ''}`}
                                    placeholder={t('additionalSettings.nomenclatureTranslations.modal.translationCodePlaceholder') || 'Enter translation code'}
                                    {...register('translationCode')}
                                />
                                {errors.translationCode && (
                                    <div className="invalid-feedback">
                                        {errors.translationCode.message}
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="submit"
                            form="nomenclatureTranslationForm"
                            className="btn btn-primary"
                            disabled={isSubmitting}
                        >
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


